import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const OutboundSKUConfigRBAC = {
  pageID: 'f226680ac71cb861d2c949086c97a3ba',
  elementID: {
    ViewPage: '77439b0729df9dd0791e18515ae62cbc',
    AddProduct: 'ec57cfd4ca6b8de85cfee64f74c979e4',
    ToggleUpdateHybrid: '7bba65eeaa100813f9b497c3f67f3587',
  },
} as const

export const useRBACOutboundSKUConfigPage = createUseRBAC(OutboundSKUConfigRBAC.elementID)

export type UseRBACOutboundSKUConfigPageType = ReturnType<typeof useRBACOutboundSKUConfigPage>
